<template>
	<div>
		<h2 class="heading-5">Our strategy</h2>
		<div class="asset-details-our-strategy-module module p-150">
			<h3 class="heading-4">{{ props.data.name }}</h3>
			<div
				class="display-flex align-items-flex-start flex-direction-column-smo gap-100 gap-300-md mt-50 pt-25-smo"
			>
				<div class="display-flex flex-direction-column gap-50 flex-1 order-1-smo text-color-gray-80">
					<RichTextComponent :blocks="props.data.description" />
					<ul v-if="props.data.marketingDetails.length" class="ml-200">
						<li v-for="(detail, i) in props.data.marketingDetails" :key="i" class="my-25">
							<strong>{{ detail.title }}:</strong> {{ detail.content }}
						</li>
					</ul>
					<BaseLink
						:link="learnMoreLink"
						mixpanel-context="Asset page strategy module"
						classes="font-weight-bold mt-50"
					/>
				</div>
				<img :src="imageUrl" alt="" role="presentation" class="strategy-img" />
			</div>
			<RichTextComponent class="body-xs text-color-content-tertiary mt-100" :blocks="props.data.disclosure" />
		</div>
	</div>
</template>

<script setup lang="ts">
import { AssetStrategy } from 'types/assets';
import { computed } from 'vue';
import { getLinkFromRoute } from '@utils/request';
import { Link } from 'types/layout';
import RichTextComponent from '@components/sanity/rich-text-component.vue';
import { useRouter } from 'vue-router';

interface Props {
	data: AssetStrategy;
}

const props = defineProps<Props>();

const router = useRouter();

const learnMoreLink = computed(
	(): Link => getLinkFromRoute(router, '/education/real-estate-strategies', 'More about our strategies')
);

const imageUrl = computed((): string => props.data.image.url);
</script>

<style lang="scss" scoped>
@use '../../../styles/utilities/respond-to.scss' as *;

.asset-details-our-strategy-module {
	margin-top: 1rem;
}

ul {
	list-style-type: disc;
}

li {
	display: list-item;
}

.strategy-img {
	width: 96px;
	height: 96px;

	@include respond-to(md) {
		width: 144px;
		height: 144px;
	}
}
</style>
